import { API_BASE_URL } from '@/environment'
import { customFetchMedia } from './apiV3UtilsMedia'

export async function get<T = any>(path: string): Promise<T> {
  return (await apiFetch(path)).json()
}

export function del(path: string) {
  return apiFetch(path, { method: 'DELETE' })
}

export function post(path: string, body: RequestInit['body']) {
  return apiFetch(path, { method: 'POST', body })
}

function apiFetch(path: string, init?: RequestInit) {
  if (!path.startsWith('/')) path = '/' + path

  const url = `${API_BASE_URL}/api/v3${path}`
  return customFetchMedia(url, init)
}
